import { _ } from '../utils.js'

export default () => {
    const loginTypeParam = 'loginType'

    const cleanUrl = () => {
        const baseQueryParams = new URLSearchParams(window.location.search)

        baseQueryParams.delete(loginTypeParam)

        window.history.replaceState(
            null,
            document.title,
            baseQueryParams?.size > 0 ? `?${baseQueryParams.toString()}` : '',
        )
    }

    const getLoginType = () => {
        const queryParams = new URLSearchParams(window.location.search)

        if (queryParams.has(loginTypeParam)) {
            return queryParams.get(loginTypeParam)
        }
    }

    const hideErroneousForgottenPassword = () => {
        const loginType = getLoginType()

        if (loginType?.length) {
            const forgottenPasswordLinks = _(
                'forgotten-password-link',
                'element',
            ).nodes()

            forgottenPasswordLinks.forEach((element) => {
                const passwordLinkType = element.dataset.forgotPassword

                if (!passwordLinkType.includes(loginType)) {
                    element.classList.add('u-hidden')
                }
            })

            cleanUrl()
        }
    }

    hideErroneousForgottenPassword()
}
